import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from '../../../common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from '../../../common/system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../../common/system/shopinfo/model/shopinfo.model';
import { DepartmentService } from '../../../common/system/department/department.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { DailySalesReportService } from './daily-sales-report.service';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { TerminalService } from '../../../common/system/terminal/terminal.service';
import { AccessLogService } from 'src/app/pages/shop/reports/access-log/access-log.service';
import { PermissionService } from 'src/app/auth/permission.service';
import { DatePipe } from '@angular/common';
import { UserGroupService } from '../../users/usergroup/usergroup.service';

@Component({
  selector: 'app-daily-sales-report',
  standalone: false,
  templateUrl: './daily-sales-report.component.html',
  styleUrl: './daily-sales-report.component.scss'
})
export class DailySalesReportComponent implements OnInit {
  markAllControlsTouched() {
    Object.values(this.editForm.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        // For nested form groups
        Object.values((control as any).controls).forEach((c: any) => c.markAsTouched());
      }
    });
  }

  user: UserInfoModel | undefined;
  title: string = "Daily Sales";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  cashierListData: any = [];
  terminalListData: any = [];
  cashierData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  permission: any;
  userListData: any = []; // Original full list from API
  isExpandedUser = false;
  showSelectedUserOnly: boolean = false;




  curFinYear!: string; // Add this to your component properties  
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  fromHour: string = '00';
  toHour: string = '00';
  shop_id: any;
  shop_name: any;
  shopListData: any = [];
  filteredShopList: any[] = [];
  terminalValidationMessage: any;
  cashierValidationMessage: any;
  terminalSelectionInvalid: boolean = false;
  cashierSelectionInvalid: boolean = false;
  isExpandedTerminal = false;
  isExpandedCashier = false;
  resetButtonEnabledForCashier: boolean = false;
  resetButtonEnabledForTerminal: boolean = false;
  showSelectedTerminalOnly: boolean = false;
  showSelectedCashierOnly: boolean = false;
  userGroupListData: any = [];
  isExpandedUserGroup = false;
  showSelectedUserGroupOnly: boolean = false;
  resetButtonEnabledForUserGroup: boolean = false;

  weekRangeValidator: ValidatorFn = (group: AbstractControl): null => {
    const weekFromCtrl = group.get('weekFrom');
    const weekToCtrl = group.get('weekTo');

    if (!weekFromCtrl || !weekToCtrl) return null;

    const weekFrom = Number(weekFromCtrl.value);
    const weekTo = Number(weekToCtrl.value);

    if (weekFromCtrl.value && weekToCtrl.value && weekTo < weekFrom) {
      weekToCtrl.setErrors({
        ...weekToCtrl.errors,
        invalidWeekRange: true
      });
    } else {
      if (weekToCtrl.hasError('invalidWeekRange')) {
        const errors = { ...weekToCtrl.errors };
        delete errors['invalidWeekRange'];
        weekToCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    return null;
  };


  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private dailySalesReportService: DailySalesReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private terminalService: TerminalService,
    private cashierService: AccessLogService,
    private userGroupService: UserGroupService,
    public dialog: MatDialog, private permissionService: PermissionService,
    private datePipe: DatePipe) {



    this.editForm = this.builder.group({
      shop_id: this.builder.control('', [Validators.required, this.shopValidator.bind(this)]),
      year: this.builder.control('', Validators.required),
      weekFrom: this.builder.control('', Validators.required),
      weekTo: this.builder.control('', Validators.required),
      shift_from: this.builder.control(5),
      terminalFilterAll: [''],
      terminalFilterSelected: [''],
      userFilterAll: [''],
      cashierFilterSelected: [''],
      userGroupFilterAll: [''],
    }, { validators: this.weekRangeValidator });

    // Mark form group as touched when weekFrom or weekTo changes
    this.editForm.get('weekFrom')?.valueChanges.subscribe(() => {
      this.editForm.markAsTouched();
    });
    this.editForm.get('weekTo')?.valueChanges.subscribe(() => {
      this.editForm.markAsTouched();
    });


    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage(null);
    });
    this.permission = this.permissionService.getPagePermission("daily-sales-report");
    this.editForm.get('shop_id')?.valueChanges.subscribe(shop => {
      this.onShopChange(shop);
    });
    // Load saved data if it exists
    // this.loadFromSessionStorage();
    // Set all days as checked by default
    // const daysGroup = this.editForm.get('days') as FormGroup;
    // this.daysOfWeek.forEach(day => {
    //   daysGroup.addControl(day, new FormControl(true)); // ✅ checked by default
    // });

  }

  // ngOnInit(): void {
  //   this.shopList();
  //   this.loadData();
  //   // this.cashierList();
  //   // this.userGroupList();
  //   let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
  //   this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
  //   if (this.user?.user_type == 'SHOP') {
  //     // Set the shop_id form control's value to the user's shop_id
  //     this.editForm.get('shop_id')?.setValue({ id: this.user.shop_id, name: this.user.shop_info.name, code: this.user.shop_info.code });
  //     this.terminalList();
  //   }
  // }

  ngOnInit(): void {
    // 1. GET USER FROM SESSION FIRST
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;

    // 2. Set default shop based on User Type (Pre-API call setup)
    if (this.user?.user_type == 'SHOP') {
      this.editForm.get('shop_id')?.setValue({
        id: this.user.shop_id,
        name: this.user.shop_info.name,
        code: this.user.shop_info.code
      });
      // Load terminals immediately for Shop users
      this.terminalList();
    }

    // 3. Load Data
    this.shopList(); // Now this function can access 'this.user'
    this.loadData();
  }

  toggleContent(divData: string): void {
    if (divData == "terminal") {
      this.isExpandedTerminal = !this.isExpandedTerminal;
    }
    if (divData == "cashier") {
      this.isExpandedCashier = !this.isExpandedCashier;
    }
  }

  // selectedDays(): string[] {
  //   const days = this.editForm.get('days')?.value;
  //   return Object.keys(days).filter(day => days[day]);
  // }

  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('fromHour')?.value;
      const to = group.get('toHour')?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }
  // getCurrentWeek(weeks: any[]): any {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  //   return weeks.find(week => {
  //     const startDate = new Date(week.start_date);
  //     const endDate = new Date(week.end_date);
  //     return today >= startDate && today <= endDate;
  //   });
  // }
  getNextWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      startDate.setHours(0, 0, 0, 0);
      return startDate > today;
    });
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(selectionData: any): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    if (selectionData == "terminal") {
      const selectedTerminalIds = this.terminalListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.code);

      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const terminalIds = selectedTerminalIds.length > 0 ? selectedTerminalIds : [];
      if (selectedTerminalIds.length > 0) {
        this.resetButtonEnabledForTerminal = true;
      } else {
        this.resetButtonEnabledForTerminal = false;
      }
      // if (terminalIds.length === 0) {
      //   this.terminalSelectionInvalid = true;
      //   return;
      // } else {
      //   this.terminalSelectionInvalid = false; // ✅ clear message when valid
      // }

      // Create the data object
      const reportData = {
        year: this.editForm.get('year')?.value,
        weekNo: this.editForm.get('week_no')?.value,
        shopId: terminalIds,
        sortBy: this.editForm.get('sort_by')?.value,
        sortDir: this.editForm.get('sort_order')?.value,
        isExport: 0
      };

      // Save to sessionStorage
      sessionStorage.setItem('dailySalesReportData', JSON.stringify(reportData));
    }

    if (selectionData == "cashier") {
      const selectedCashierIds = this.cashierListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const cashierIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
      if (selectedCashierIds.length > 0) {
        this.resetButtonEnabledForCashier = true;
      } else {
        this.resetButtonEnabledForCashier = false;
      }
      // console.log(selectedCashierIds.length)
      // if (cashierIds.length === 0) {
      //   this.cashierSelectionInvalid = true;
      //   return;
      // } else {
      //   this.cashierSelectionInvalid = false; // ✅ clear message when valid
      // }

      // Create the data object
      const reportData = {
        year: this.editForm.get('year')?.value,
        weekNo: this.editForm.get('week_no')?.value,
        shopId: cashierIds,
        sortBy: this.editForm.get('sort_by')?.value,
        sortDir: this.editForm.get('sort_order')?.value,
        isExport: 0
      };

      // Save to sessionStorage
      sessionStorage.setItem('dailySalescashierReportData', JSON.stringify(reportData));
    }

  }

  // loadFromSessionStorage(): void {
  //   const savedData = sessionStorage.getItem('weeklyStoreReportData');
  //   // console.log(savedData)
  //   if (savedData) {
  //     const reportData = JSON.parse(savedData);

  //     // Set form values
  //     this.editForm.patchValue({
  //       year: reportData.year,
  //       week_no: reportData.weekNo,
  //       sort_by: reportData.sortBy,
  //       sort_order: reportData.sortDir
  //     }, { emitEvent: false }); // Prevent infinite loop

  //     // Set shop selections (if shop IDs were saved)
  //     if (reportData.shopId && reportData.shopId.length > 0) {
  //       this.cashierListData.forEach((shop: any) => {
  //         shop.selected = reportData.shopId.includes(shop.item.id);
  //       });
  //     } else {
  //       // If no shops were selected before, reset all to false (treat as "ALL")
  //       this.cashierListData.forEach((shop: any) => shop.selected = false);
  //     }

  //     // Manually trigger year change if needed
  //     if (reportData.year) {
  //       this.onYearChange();
  //     }
  //   }
  // }




  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    // console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Only include weeks whose end_date is less than or equal to today (current week)
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const filteredWeeks = selectedFinYear.weeks.filter((week: any) => {
        const weekStartDate = new Date(week.start_date);
        weekStartDate.setHours(0, 0, 0, 0);
        return weekStartDate <= today;
      });
      this.weeks = filteredWeeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
      }))
        .sort((a: any, b: any) => b.week_no - a.week_no);

      const currentWeek = this.getCurrentWeek(this.weeks);
      if (currentWeek) {
        this.editForm.get('weekFrom')?.setValue(currentWeek.week_no);
        this.editForm.get('weekTo')?.setValue(currentWeek.week_no);
      } else if (this.weeks.length > 0) {
        // Fallback to first week if current week not found
        this.editForm.get('weekFrom')?.setValue(this.weeks[0].week_no);
        this.editForm.get('weekTo')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('weekFrom')?.setValue(null);
      this.editForm.get('weekTo')?.setValue(null);
    }
  }

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };

  }

  loadData(): void {

    let requestData = this.buildRequestData();
    this.dailySalesReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        // Determine the current financial year (e.g., 2025-26 for early 2026)
        const today = new Date();
        let currentFinYearNum = today.getFullYear();
        // If before April, financial year is previous year
        if (today.getMonth() < 3) {
          currentFinYearNum = currentFinYearNum - 1;
        }
        // Only show financial years up to the current financial year
        this.financialYears = response.data.finYears.filter((fy: any) => fy.year <= currentFinYearNum);
        this.years = this.financialYears.map(fy => fy.year);

        if (!this.editForm.get('year')?.value) {
          this.curFinYear = response.data.curFinYear;
          if (this.curFinYear) {
            const yearValue = parseInt(this.curFinYear);
            this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

            const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
            if (currentFinYear) {

              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const filteredWeeks = currentFinYear.weeks.filter((week: any) => {
                const weekStartDate = new Date(week.start_date);
                weekStartDate.setHours(0, 0, 0, 0);
                return weekStartDate <= today;
              });

              this.weeks = filteredWeeks.map((week: any) => ({
                ...week,
                displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
              }))
                .sort((a: any, b: any) => b.week_no - a.week_no);
              const currentWeek = this.getCurrentWeek(this.weeks);
              const nextWeek = this.getNextWeek(this.weeks);
              if (currentWeek) {
                this.editForm.get('weekFrom')?.setValue(currentWeek.week_no);
                this.editForm.get('weekTo')?.setValue(currentWeek.week_no);
              } else if (this.weeks.length > 0) {
                this.editForm.get('weekFrom')?.setValue(this.weeks[0].week_no);
                this.editForm.get('weekTo')?.setValue(this.weeks[0].week_no);
              }
            }
          }
        }
      } else {
        console.error('API Error:', response.message);
      }
    });
  }

  // shopList(): void {
  //   let requestData = {
  //     search: {
  //       filters: {
  //         filter: [],
  //         scope: { offset: 0, limit: 1000000 }
  //       },
  //       sort: [{ column: "shop.name", order: "ASC" }]
  //     }
  //   }

  //   this.dailySalesReportService.getShopList(requestData).subscribe({
  //     next: (response: any) => {
  //       this.shopListData = response.data.shops;
  //       this.filteredShopList = this.shopListData.slice();
  //       // If user is SHOP type, set shop_id to the actual object from shopListData
  //       if (this.user?.user_type == 'SHOP') {
  //         const shopObj = this.shopListData.find((s: any) => s.id === this.user!.shop_id);
  //         if (shopObj) {
  //           this.editForm.get('shop_id')?.setValue(shopObj);
  //         }
  //       }
  //     },
  //     error: (error: any) => {
  //       console.error('Error fetching shops:', error);
  //     }
  //   });
  // }

  shopList(): void {
    let requestData = {
      search: {
        filters: {
          filter: [],
          scope: { offset: 0, limit: 1000000 }
        },
        sort: [{ column: "shop.name", order: "ASC" }]
      }
    }

    this.dailySalesReportService.getShopList(requestData).subscribe({
      next: (response: any) => {
        this.shopListData = response.data.shops;
        this.filteredShopList = this.shopListData.slice();

        // Case 1: Specific SHOP User
        if (this.user?.user_type == 'SHOP') {
          const shopObj = this.shopListData.find((s: any) => s.id === this.user!.shop_id);
          if (shopObj) {
            this.editForm.get('shop_id')?.setValue(shopObj);
          }
        }
        // Case 2: ADMIN or HQ User (shop_id is 0 or "0")
        // We use Number() to safely handle both string "0" and number 0
        else if (Number(this.user?.shop_id) === 0) {
          if (this.shopListData.length > 0) {
            // Select the first shop in the list
            const firstShop = this.shopListData[0];
            this.editForm.get('shop_id')?.setValue(firstShop);
          }
        }
      },
      error: (error: any) => {
        console.error('Error fetching shops:', error);
      }
    });
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  terminalList(): void {

    let requestData = {
      search: {

        filters: {
          simpleSearch: [],
          advSearch: [
            {
              column: "is_system",
              operator: "=",
              value: 0
            }
          ],
          scope: {
            limit: 10000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]

      }
    }

    this.dailySalesReportService.getTerminalList(requestData).subscribe({
      next: (response: any) => {
        this.terminalListData = [];
        let index = 0;
        response.data.terminals.forEach((item: any) => {
          const data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
      },
      error: (error: any) => {
        // Handle error here
        console.error('Error fetching terminal list:', error);
      }
    });
  }

  /**
   * Get cashier list
   */
  // cashierList(): void {
  //   this.dailySalesReportService.getUsers().subscribe({
  //     next: (response: any) => {
  //       this.cashierListData = [];
  //       let index = 0;
  //       response.data.users.forEach((item: any) => {
  //         const data = { index: index, item: item, selected: false };
  //         this.cashierListData.push(data);
  //         index++;
  //       });
  //     },
  //     error: (error: any) => {
  //       // Handle error here
  //       console.error('Error fetching users:', error);
  //     }
  //   });

  // }


  cashierList(shopId: string): void {
    let requestData = {
      shopId: shopId,
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { limit: 10000, offset: 0 }
        },
        sort: [{ column: "name", order: "asc" }]
      }
    };

    this.dailySalesReportService.getUsers(requestData).subscribe({
      next: (response: any) => {
        this.userListData = []; // Store in master list
        if (response.status === 'SUCCESS' && response.data.users) {
          response.data.users.forEach((item: any, index: number) => {
            this.userListData.push({ index, item, selected: false });
          });
        }
      },
      error: (error: any) => console.error('Error fetching users:', error)
    });
  }


  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }


  exportClicked(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    // if (this.editForm.invalid) {
    //   this.editForm.markAllAsTouched(); // This will trigger error messages
    //   return;
    // }
    // Find the selected year object
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.editForm.get('year')?.value);

    // Find the week objects for weekFrom and weekTo
    const weekFromObj = selectedFinYear?.weeks.find((w: any) => w.week_no === this.editForm.get('weekFrom')?.value);
    const weekToObj = selectedFinYear?.weeks.find((w: any) => w.week_no === this.editForm.get('weekTo')?.value);
    // Only shopId (number) 
    const shopId = this.editForm.get('shop_id')?.value?.id;
    this.shop_name = this.shopListData.find((s: any) => s.id === shopId)?.name;
    // Start date of weekFrom
    const dateFrom = weekFromObj ? weekFromObj.start_date : null;
    // End date of weekTo, only if weekTo >= weekFrom
    let dateTo = null;
    if (weekFromObj && weekToObj && weekToObj.week_no >= weekFromObj.week_no) {
      dateTo = weekToObj.end_date;
    }
    console.log(this.editForm.valid)
    if (this.editForm.valid) {
      const selectedCashierIds = this.cashierListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      const selectedTerminalIds = this.terminalListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.code);
      // const cashierIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
      const selectedUserIds = this.userListData
        .filter((u: any) => u.selected)
        .map((u: any) => u.item.id);
      const terminalIds = selectedTerminalIds.length > 0 ? selectedTerminalIds : [];
      var rawDateFrom = this.editForm.get('period_from')?.value;
      var formattedDateFrom = moment(rawDateFrom).format('DD-MM-YYYY');
      // var days = this.selectedDays();
      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        shopId: shopId,
        shopName: (this.shop_name) ? this.shop_name : this.shopListData.find((s: any) => s.id === shopId)?.name,
        year: this.editForm.get('year')?.value,
        dateFrom: dateFrom, // Start date of weekFrom
        dateTo: dateTo,
        // dateFrom: formattedDateFrom,
        shiftFrom: this.editForm.get('shift_from')?.value,
        terminalId: terminalIds,
        cashierId: selectedUserIds,
        isExport: 1
      };
      console.log(reportData);
      this.IsDownloading = true;
      if (reportData) {
        this.dailySalesReportService.exportDailySalesReport(reportData).subscribe({
          next: (response) => {
            // Handle "No data found" response
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const text = reader.result as string;
                const json = JSON.parse(text);
                if (json.status === 'NO_DATA_FOUND') {
                  let snackBarData: SnackBarData = {
                    message: 'No data found.',
                    title: 'No Data!!!',
                    type: 'warn'
                  }
                  this.IsDownloading = false;
                  this.snackBarService.openSnackBar(snackBarData);
                  return;
                }
              } catch (e) {
                // Not JSON, treat as file
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'daily-sales-report.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.IsDownloading = false;
              }
            };
            reader.readAsText(response);
          },
          error: (error) => {
            this.IsDownloading = false;
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    } else {
      this.markAllControlsTouched(); // This will trigger error messages for all controls
    }
  }

  // --- Select All and Reset ---



  // --- Filtered getters for Terminal ---
  get filteredTerminalListData() {
    let filteredList = this.terminalListData;
    if (this.showSelectedTerminalOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('terminalFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllTerminal() {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage('terminal');
  }

  getSelectAllIconTerminal(): string {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    const someSelected = this.terminalListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  // --- Filtered getters for Cashier ---
  get filteredCashierListData() {
    let filteredList = this.cashierListData;
    if (this.showSelectedCashierOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('userFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }


  getSelectAllIconUser(): string {
    const allSelected = this.userListData.every((item: any) => item.selected);
    const someSelected = this.userListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  // --- Selected count getters (for Reset button) ---
  get selectedTerminalSourcesCount(): number {
    return this.terminalListData?.filter((item: any) => item.selected)?.length || 0;
  }
  get selectedUserSourcesCount(): number {
    return this.userListData?.filter((item: any) => item.selected)?.length || 0;
  }

  // --- Optional: handle selection change if needed ---
  onListSelectionChange(type: string) {
    // Implement any logic you need when selection changes
  }
  filterShops() {
    const value = this.editForm.get('shop_id')?.value;
    if (!value || value === '' || value === 'ALL' || (typeof value === 'object' && value.name === 'ALL')) {
      this.filteredShopList = this.shopListData.slice();
      return;
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name?.toLowerCase() || '');
    this.filteredShopList = this.shopListData.filter((shop: any) =>
      shop.name.toLowerCase().includes(filterValue)
    );
  }

  displayShop(shop: any): string {
    return shop && shop.name ? shop.name : '';
  }

  clearShop() {
    this.editForm.get('shop_id')?.setValue('');
    this.filteredShopList = this.shopListData.slice();
  }
  shopValidator(control: any) {
    if (!control.value) return { invalidShop: true };

    // Allow "ALL" option (with id: null)
    if (typeof control.value === 'object' && (control.value.id === null || control.value.name === 'ALL')) {
      return null;
    }

    if (typeof control.value === 'object' && this.shopListData.some((shop: { id: any; }) => shop.id === control.value.id)) {
      return null;
    }
    if (typeof control.value === 'string' && this.shopListData.some((shop: { name: any; }) => shop.name === control.value)) {
      return null;
    }
    return { invalidShop: true };
  }

  onShopChange(shop: any) {
    if (shop && shop.id) {
      this.getTerminalsForShop(shop.id);
    } else {
      this.terminalListData = [];
    }
    if (shop && shop.id) {
      this.userGroupList(shop.id);
    } else {
      this.userGroupListData = [];
    }
    if (shop && shop.id) {
      this.cashierList(shop.id);
    } else {
      this.userListData = [];
    }
  }

  getTerminalsForShop(shopId: string) {
    let requestData = {
      shopId: shopId,
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [
            {
              column: "is_system",
              operator: "=",
              value: 0
            }
          ],
          scope: {
            limit: 10000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]
      }
    };


    this.dailySalesReportService.getHqTerminalList(requestData).subscribe({
      next: (response: any) => {
        this.terminalListData = [];
        let index = 0;
        response.data.terminals.forEach((item: any) => {
          const data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
      },
      error: (error: any) => {
        this.terminalListData = [];
        console.error('Error fetching terminal list:', error);
      }
    });
  }


  get filteredUserGroupListData() {
    let filteredList = this.userGroupListData;
    if (this.showSelectedUserGroupOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('userGroupFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: any) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  // 5. Add the method to fetch User Groups
  userGroupList(shopId: string): void {
    let requestData = {
      shopId: shopId,
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { limit: 10000, offset: 0 }
        },
        sort: [{ column: "name", order: "asc" }]
      }
    };

    this.userGroupService.getList(requestData).subscribe({
      next: (response: any) => {
        this.userGroupListData = [];
        let index = 0;
        response.data.user_groups.forEach((item: any) => {
          const data = { index: index, item: item, selected: false };
          this.userGroupListData.push(data);
          index++;
        });
      },
      error: (error: any) => {
        console.error('Error fetching user groups:', error);
      }
    });
  }

  // 6. Add Helper Methods for UI interactions
  // toggleSelectAllUserGroup() {
  //   const allSelected = this.userGroupListData.every((item: any) => item.selected);
  //   this.userGroupListData.forEach((item: any) => (item.selected = !allSelected));
  // }
  toggleSelectAllUserGroup() {
    const allSelected = this.userGroupListData.every((item: any) => item.selected);
    this.userGroupListData.forEach((item: any) => (item.selected = !allSelected));

    // Trigger the user filter cleanup
    this.onUserGroupChange();
  }

  getSelectAllIconUserGroup(): string {
    const allSelected = this.userGroupListData.every((item: any) => item.selected);
    const someSelected = this.userGroupListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  get selectedUserGroupSourcesCount(): number {
    return this.userGroupListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get filteredUserListData() {
    let filteredList = this.userListData;

    // Step A: Filter by selected User Groups
    const selectedGroupIds = this.userGroupListData
      .filter((g: any) => g.selected)
      .map((g: any) => g.item.id);

    if (selectedGroupIds.length > 0) {
      filteredList = filteredList.filter((u: any) =>
        selectedGroupIds.includes(u.item.user_group_id)
      );
    }

    // Step B: Filter by "Show Selected Only" toggle
    if (this.showSelectedUserOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }

    // Step C: Filter by Text Search
    const filterText = this.editForm.get('userFilterAll')?.value?.toLowerCase() || '';
    if (filterText) {
      filteredList = filteredList.filter((item: any) =>
        item.item.name.toLowerCase().includes(filterText)
      );
    }

    return filteredList;
  }

  // onUserGroupChange() {
  //   // 1. Get IDs of currently selected groups
  //   const selectedGroupIds = this.userGroupListData
  //     .filter((g: any) => g.selected)
  //     .map((g: any) => g.item.id);

  //   // 2. Iterate through all users
  //   this.userListData.forEach((u: any) => {
  //     // Only run cleanup if at least one group is selected (Filtering Mode)
  //     if (selectedGroupIds.length > 0) {

  //       // Check if this user's group ID exists in the selected list
  //       // We use `some` with `==` to allow matching String "1" with Number 1
  //       const isGroupSelected = selectedGroupIds.some((id: any) => id == u.item.user_group_id);

  //       // If the user is currently selected, but their group is NO LONGER selected...
  //       if (u.selected && !isGroupSelected) {
  //         // ...deselect them
  //         u.selected = false;
  //       }
  //     }
  //   });
  // }

  // onUserGroupChange() {
  //   // 1. Get IDs of currently selected groups
  //   const selectedGroupIds = this.userGroupListData
  //     .filter((g: any) => g.selected)
  //     .map((g: any) => g.item.id);

  //   // 2. Iterate through all users to sync selection with visibility
  //   this.userListData.forEach((u: any) => {
  //     if (selectedGroupIds.length > 0) {
  //       // If groups are selected, and this user belongs to a group NOT selected...
  //       const isGroupSelected = selectedGroupIds.some((id: any) => id == u.item.user_group_id);

  //       if (!isGroupSelected) {
  //         u.selected = false; // Deselect because the user is now hidden
  //       }
  //     } 
  //     // If selectedGroupIds.length === 0, all users are visible, 
  //     // so we don't need to force-deselect anyone.
  //   });
  // }

  onUserGroupChange() {
    // 1. Get IDs of currently selected groups
    const selectedGroupIds = this.userGroupListData
      .filter((g: any) => g.selected)
      .map((g: any) => g.item.id);

    // 2. Iterate through all users
    this.userListData.forEach((u: any) => {
      if (selectedGroupIds.length > 0) {
        // MODE: Filtering active
        // If the user's group is NOT in the selection, they must be unselected
        const isGroupSelected = selectedGroupIds.some((id: any) => id == u.item.user_group_id);
        if (!isGroupSelected) {
          u.selected = false;
        }
      } else {
        // MODE: All groups unchecked
        // Logic: If you want all user checkboxes to clear when the group filter is removed:
        u.selected = false;
      }
    });
  }


  toggleSelectAllUser() {
    // Get the users currently visible based on group/search filters
    const visibleUsers = this.filteredUserListData;
    const allVisibleSelected = visibleUsers.every((u: any) => u.selected);

    // Toggle selection only for visible items
    visibleUsers.forEach((u: any) => {
      u.selected = !allVisibleSelected;
    });

    this.saveToSessionStorage('cashier');
  }
}
